module.exports = __webpack_public_path__ + "static/media/dummyuser.79dd11a9.png";